export const submit = (form) => {
    if (form.requestSubmit) {
        form.requestSubmit();
    }
    else if (!form.reportValidity()) {
        return;
    }
    else {
        const submitEvent = new Event('submit', {
            cancelable: true
        });
        form.dispatchEvent(submitEvent);
        if (!submitEvent.defaultPrevented) {
            form.submit();
        }
    }
};
//# sourceMappingURL=submit.js.map